export const VoidLogger = {
    warn (..._args) {
        return undefined;
    },
    info (..._args) {
        return undefined;
    },
    error (..._args) {
        return undefined;
    },
    table (..._args) {
        return undefined;
    }
};

//# sourceMappingURL=Void.js.map